import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (resource) =>
    present(
      repository
        .getUnReadNotificationsNbr(resource)
        .then((nbr) => ({ resource, nbr }))
        .catch(() => Promise.reject(resource)),
    );
}

export type { Interactor };

export { createInteractor };
